import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * DealerLinkRedirect
 * Catches /:dealerSlug/rv/:shortcode routes. Resolves the cloaked shortcode
 * against the API, then window.location.replace()s to the dealer's real
 * inventory URL. A minimal "hand-off" screen shows for the ~200ms round trip
 * so the buyer never sees a blank flash.
 */
export default function DealerLinkRedirect() {
  const { shortcode } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/dealer-links/resolve/${shortcode}`);
        if (cancelled) return;
        const target = res?.data?.target_url;
        if (!target) {
          setError('This link is no longer available.');
          return;
        }
        // Use replace so the cloaked URL doesn't stay in browser history.
        window.location.replace(target);
      } catch (e) {
        if (!cancelled) {
          setError(e?.response?.data?.detail || 'This link is no longer available.');
        }
      }
    })();
    return () => { cancelled = true; };
  }, [shortcode]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#05070d] text-white px-6" data-testid="dealer-link-redirect">
      <div className="max-w-md text-center">
        {error ? (
          <>
            <h1 className="text-2xl font-bold mb-3">Link unavailable</h1>
            <p className="text-white/70 mb-6">{error}</p>
            <a href="/" className="inline-block px-5 py-3 rounded-full bg-white text-[#05070d] font-semibold hover:bg-white/90">
              Return to RV Match AI
            </a>
          </>
        ) : (
          <>
            <div className="mx-auto mb-4 h-10 w-10 rounded-full border-2 border-white/20 border-t-white animate-spin" />
            <h1 className="text-lg font-semibold">Taking you to the RV…</h1>
            <p className="text-white/60 text-sm mt-1">Powered by RV Match AI</p>
          </>
        )}
      </div>
    </div>
  );
}
